import { render } from "./Landingpage.vue?vue&type=template&id=6bd6584c"
import script from "./Landingpage.vue?vue&type=script&lang=js"
export * from "./Landingpage.vue?vue&type=script&lang=js"

import "./Landingpage.vue?vue&type=style&index=0&id=6bd6584c&lang=css"
script.render = render

export default script